var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-storages',{attrs:{"id":"contacts","storages":_vm.storages,"title":"Как нас найти?"}})
}
var staticRenderFns = []

export { render, staticRenderFns }